/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_Check_StaleInputs */

const vi_grower_area_camera_check_stale = /** @type {(inputs: Grower_Area_Camera_Check_StaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Token vừa đổi. Lưu camera rồi kiểm tra lại để biết kết quả của token mới.`)
};

/**

* @param {Grower_Area_Camera_Check_StaleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_check_stale = /** @type {((inputs?: Grower_Area_Camera_Check_StaleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_Check_StaleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_check_stale(inputs)
});